<template>
  <div class="Poplayer-box" v-if="dialogVisable">
    <div class="Poplayer PoplayerOne">
      <div v-if="!hideCloseBtn" class="close" @click="handleCloseTip">
        <img src="../assets/images/close.png" alt />
      </div>
      <h3>{{popTipsCont.title}}</h3>
      <div class="prop-content" v-html="popTipsCont.context"></div>
      <div class="oprate">
        <span
          v-for="(item, index) in popTipsCont.btns"
          :key="index"
          class="confirm bg-base btn cursor"
          @click="handleEvent(item.event)"
        >{{item.text}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "popTips",
  props: ["dialogVisable", "popTipsCont", 'hideCloseBtn'],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  updated() {},
  created() {},
  computed: {},
  methods: {
    // 关闭弹框
    handleCloseTip() {
      this.$emit("handleCloseTip");
    },
    // 确定*****提交
    handConfirm() {
      this.$emit("handConfirm");
    },
    // 取消
    handCancel() {
      this.$emit("handCancel");
    },
    handleEvent (event) {
      this[event]();
    }
  }
};
</script>

<style lang="less">
</style>
